import { useParams } from "react-router-dom";

import style from "./style.module.scss";
import { requireLogin } from "../../../security";
import Header from "./header";
import ProductList from "./product-list";
import Product from "./product";

function Admin() {
  const { uid } = useParams();

  const breadcrumbItems = uid
    ? [{ label: "Admin", link: "/admin" }, { label: `Product ${uid}` }]
    : [{ label: "Admin" }];

  return (
    <section className={style.container}>
      <div className={style.header}>
        <Header breadcrumbItems={breadcrumbItems} />
      </div>
      <div className={style.content}>{uid ? <Product uid={uid} /> : <ProductList />}</div>
    </section>
  );
}

export default requireLogin({ role: "admin" })(Admin);
